export default __webpack_public_path__ + "images/logo-text-white.2b75b4.png";